import env from '../../config/environment';
import React, { useEffect, useState } from 'react';
import { RootState, useAppSelector } from '../../redux/store';
import {
  HeapProjectId,
  PromotionLevel,
  SingletonHooksContainer,
  useHeaper,
} from '@equipmentshare/heaper';

interface HeaperComponentProps {
  accessToken: string;
  idToken: string;
}

const HeaperProvider = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [idToken, setIdToken] = useState<string | null>(null);

  const authContext = useAppSelector((state: RootState) => state.auth.authContext);

  const getHeapProjectId = (level: PromotionLevel): HeapProjectId =>
    HeapProjectId[level as keyof typeof HeapProjectId];

  useEffect(() => {
    setAccessToken(authContext?.accessToken ?? null);
    setIdToken(authContext?.idToken ?? null);

    if (authContext?.accessToken) {
      // Inject heaper script when user logs in
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
        window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};

        heap.load("${getHeapProjectId(env.HEAPER_ENV as PromotionLevel)}");
      `;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    } else {
      // If user logs out, ensure script is removed
      const script = document.querySelector('script[src*="heap"]');
      if (script) {
        document.head.removeChild(script);
      }
    }
  }, [authContext]);

  return (
    <>
      <SingletonHooksContainer />
      {accessToken && idToken ? <HeaperSetup accessToken={accessToken} idToken={idToken} /> : null}
    </>
  );
};

const HeaperSetup: React.FC<HeaperComponentProps> = ({ accessToken, idToken }) => {
  const heaperEnv = env.HEAPER_ENV as PromotionLevel;

  const heaperOptions = {
    accessToken,
    idToken,
    heap: false,
    intercom: true, // only intercom
    silent: false,
  };

  useHeaper('EquipmentShare.com', heaperEnv, heaperOptions);

  return null;
};

export default HeaperProvider;
